<template>
  <div @click="openLayer">
    <slot/>
  </div>
</template>

<script>/**
 * 
 * <p><b>Copyright © 2010-2022开发公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022年10月16日</li>
 * <li>@author     : 开发者</li>
 * </ul>
 * 
 */
import {layer} from "@layui/layer-vue";
import {routeList} from "@/router";
import {h} from "vue";

export default {
  name: "RouterLink",
  emits: ['success'],
  props: {
    to: Object,
    tag: String,
    icon: String,
    width: {
      type: String,
      default: "50vw"
    },
  },
  data() {
    return {
      title: ""
    }
  },
  methods: {
    openLayer() {
      let find = routeList.find(value => value.name === this.to.name);
      this.title = find.title;
      let layerId = layer.drawer({
        title: this.title,
        shadeClose: false,
        zIndex: 999,
        area: [this.width, '100vh'],
        content: h(find.component, Object.assign(this.to.params, {
          onSuccess: (args) => {
            this.$emit('success', args)
          },
          onClose: (args) => {
            layer.close(layerId);
          }
        })),
        onClose: (args) => {
          this.$emit('success', args)
        }
      });
    }
  },
}
</script>
